<template>
  <div class="d-flex justify-content-end align-items-center gap-3">
    <div class="small text-muted">
      Página <strong>{{ currentPage }}</strong> de {{ lastPage }}
    </div>
    
    <div>
      <button
        @click="$emit('fetch-views', 1)"
        class="btn btn-sm btn-outline-secondary mr-2"
        :disabled="currentPage === 1"
      >
        Primera
      </button>
      <button
        @click="$emit('fetch-views', currentPage - 1)"
        class="btn btn-sm btn-outline-secondary mr-2"
        :disabled="currentPage === 1"
      >
        Anterior
      </button>
      <button
        @click="$emit('fetch-views', currentPage + 1)"
        class="btn btn-sm btn-outline-secondary mr-2"
        :disabled="currentPage >= lastPage"
      >
        Siguiente
      </button>
      <button
        @click="$emit('fetch-views', lastPage)"
        class="btn btn-sm btn-outline-secondary"
        :disabled="currentPage >= lastPage"
      >
        Última
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataPagination",
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 1
    },
    lastPage: {
      type: Number,
      required: true,
      default: 1
    },
    hasMorePages: {
      type: Boolean,
      required: false,
      default: false
    },
  },
};
</script>

<style scoped>
.gap-3 {
  gap: 1rem;
}
</style>
